import React from 'react'
import { Heading, GContainer, Input, CustomBsSearch } from '../../style/Navbar'
import { SettingIcon } from '../../style/Home'
import Setting from "../../assets/Pmc/setting.svg";
import './Navbar.css';

export const Navbar = (props) => {
  return (
    <GContainer className="noPadd app-navbar">
      <div className="app-navbar-top">
        <div className="app-navbar-search">
          <div className="app-navbar-searchbar">
            <CustomBsSearch className="app-navbar-search-icon" />
            <Input
              className="app-navbar-search-input"
              placeholder="Search"
            />
          </div>
        </div>
        <div className="settingIcon app-navbar-setting-wrap">
          <SettingIcon
            src={Setting}
            alt="setting"
            onClick={props.handleSettingClick}
          />
        </div>
      </div>
      <Heading className="app-navbar-heading">
        {props.Heading ? props.Heading : "Patient chart"}
      </Heading>
      <div className="app-navbar-provider-text">
        Provider: TOM COLLINS
      </div>
    </GContainer>
  );
};
